import { combineReducers } from 'redux';
import { createSlice } from '@reduxjs/toolkit';

import list from './List/reducer';
import create from './Create/reducer';
import edit from './Edit/reducer';

const name = 'main';

const initialState = {
  organizations: [],
  loaded: false,
  loading: false,
  error: null,
};

const main = createSlice({
  name,
  initialState,
  reducers: {
    getLandingPagesRequest: (state) => {
      state.loading = true;
      state.loaded = false;
    },
    getLandingPagesSuccess: (state, { payload }) => {
      state.organizations = payload.organizations;
      state.loading = false;
      state.loaded = true;
    },
    getLandingPagesFailure: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
  },
});

export const { actions, reducer } = main;

const donateFormsReducer = combineReducers({
  main: reducer,
  list,
  create,
  edit,
});

export default donateFormsReducer;
